export default "__VITE_ASSET__Ci$X$vHG__"